// Author Lin
// Date 2021-07-06 17:27:43

import * as model from "@/model/sithMes/inventory/SithMesInventoryBinStatusModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryBinStatus(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .buildStore()
